<template>
  <div class="btn-filter-toggle__container">
      <button
        v-on:click.prevent="togglePopover()"
        class="a-btn btn-filter-toggle">
        {{copyFilter}}
        <span class="btn-filter-toggle__count" v-show="filterActiveCount > 0">({{filterActiveCount}})</span>
        <i class="ico ico-sliders"></i>
      </button>
      <div
        :class="{'is-active': showPopover}"
        class="filter-popover page-popover">
        <div class="filter-popover__inner page-popover__inner">
          <button
            v-on:click.prevent="togglePopover()"
            type="button"
            class="filter-popover__close page-popover__close">
            <span class="sr-only">{{copyReset}}</span>
            <i class="icon icon-times"></i>
          </button>
          <div class="filter-popover__title page-popover__title">
            <span>{{copyFilter}}</span>
            <i class="ico ico-sliders"></i>
          </div>
          <div class="filter-list">
            <div
              v-for="filter in filterList"
              :key="filter.key"
              :class="filter.class"
              class="filter-list__item">
              <filter-button
                v-if="filter.type === 'button'"
                :selected="filter.selected"
                :filter="filter"></filter-button>
              <filter-select-v2
                v-if="filter.type === 'selectV2'"
                :selected="filter.selected"
                :filter="filter"
                :alreadyOpened="componentIdOpened"
                v-on:onOpen="filterOpened"></filter-select-v2>
              <filter-color
                v-if="filter.type === 'color'"
                :filter="filter"
                :alreadyOpened="componentIdOpened"
                v-on:onOpen="filterOpened"></filter-color>
            </div>

            <p class="filter-list__footer-action">
              <button
                v-on:click.prevent="resetFilter()"
                type="button"
                class="a-btn a-btn--border spacer-b-sm a-btn-sm">
                {{ copyReset }} <i class="ico ico-ccw"></i>
              </button>
              <button
                v-on:click.prevent="togglePopover()"
                type="button"
                class="a-btn a-btn-primary">{{ nbResults }} {{ copyKwayFound }} <i class="ico ico-angle-right"></i>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import filterSelectV2 from '@/components/filter/FilterSelectV2'
  import filterColor from '@/components/filter/FilterColor'
  import filterButton from '@/components/filter/FilterButton'

  export default {
    computed: {
      filterList: function () {
        return this.$store.getters.allFilters
      },
      copyFilter: function () {
        return this.$store.getters.copy('filter')
      },
      copyReset: function () {
        return this.$store.getters.copy('reset')
      },
      copyKwayFound: function () {
        return this.$store.getters.copy(this.nbResults > 0 ? 'kway_founds' : 'kway_found')
      },
      nbResults: function () {
        return this.$store.getters.productCount
      },
      showPopover: function () {
        return this.$store.getters.openFilterPopover
      },
      filterActiveCount: function () {
        return this.$store.getters.selectedFiltersString.length
      }
    },
    data: function () {
      return {
        componentIdOpened: 0
      }
    },
    methods: {
      filterOpened (componentId) {
        this.componentIdOpened = componentId
      },
      togglePopover: function () {
        this.$store.dispatch('toggleFilterPopover', !this.showPopover)
      },
      resetFilter: function () {
        this.$store.dispatch('resetFilters')
        this.togglePopover()
      }
    },
    components: {
      filterSelectV2,
      filterColor,
      filterButton
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Filters.vue